import {Button} from 'antd';
import {useNavigate} from 'react-router-dom';

import {ResetPasswordComponent} from '../../../component/common/ResetPasswordComponent';

const ForgotPasswordScreen = () => {
  const navigate = useNavigate();

  const handleBackToLogin = () => {
    navigate('auth/login');
  };

  return (
    <div className={'w-full h-full flex justify-center items-center'}>
      <div className={'w-full max-w-md'}>
        <ResetPasswordComponent />
        <div className={'text-center mt-4'}>
          <Button
            onClick={handleBackToLogin}
            className={'!text-primary-700 border-none hover:underline focus:outline-none'}
          >
                        Back to Login
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ForgotPasswordScreen;
